import React from 'react';
import {useHistory} from 'react-router-dom/cjs/react-router-dom';

import {routes} from '../../../../util/uiconstants';

import Button from '../../../CoreWrappers/Button';
import StyledControls from './StyledControls';

import { adobeAnalytics } from '@ey/voltron-analytics';
import { clickActionArgs} from '../../../AdobeAnalytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	locationInPages,
	clickActionNames,
	buttonNames
} from '../../../AdobeAnalytics/constants.js';

const Controls = ({values, errors, handleChange, handleSubmit, handleReset, isFormValid, labels}) => {
	const history = useHistory();

	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	const renderButton = (btnProps) => {
		const props = {
			...btnProps
		};

		return <Button {...props} />;
	};

	const handleClick = (name) => {		
		switch (name) {
			case buttonNames.save:
				handleSubmit(() => history.push(`/${routes.project.root}`, null));
				break;
			case buttonNames.cancel:
			default:
				history.push(`/${routes.project.root}`, null);
				break;
		}

		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				`${clickActionNames.createGroupOversightProject}:${name}`,
				controlTypes.button,
				locationInPages.footerBottom,
				`${window.location.origin}/${routes.project.root}`
			)
		);
	};

	const saveProps = {
		label: labels.save,
		size: "medium",
		onClick: handleClick.bind(this, buttonNames.save),
	};

	const cancelProps = {
		label: labels.cancel,
		variant: 'ghost',
		size: "medium",
		onClick: handleClick.bind(this, buttonNames.cancel),
	};

	return (
		<StyledControls>
			{renderButton(cancelProps)}
			{renderButton(saveProps)}
		</StyledControls>
	);
};

export default Controls;
